// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder__1Ty88","button":"button__3CV7H"};